// Auto-generated from home.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
/* ---------- cycling word (crossfade swap, no visible scroll) ---------- */
(function(){
  var words = ["reference","compliance","interoperability","issuance"];
  var track = document.getElementById('cycleTrack');
  var wrap  = document.getElementById('cycle');
  var measure = document.getElementById('cycleMeasure');
  if(!track) return;

  var spans = words.map(function(w){
    var s = document.createElement('span');
    s.className='w'; s.textContent=w;
    track.appendChild(s); return s;
  });

  var idx = 0;

  function measureWord(w){
    measure.textContent = w;
    measure.style.fontSize = getComputedStyle(wrap).fontSize;
    return measure.getBoundingClientRect().width;
  }
  function setWidth(w){
    if(window.matchMedia('(max-width: 760px)').matches){ wrap.style.width = ''; return; }
    wrap.style.width = (Math.ceil(measureWord(w)) + 3) + 'px';
  }
  function show(i){
    spans.forEach(function(s,k){ s.classList.remove('is-in','is-out'); if(k===i) s.classList.add('is-in'); });
    setWidth(words[i]);
  }

  show(0);
  window.addEventListener('load', function(){ setWidth(words[idx]); });
  window.addEventListener('resize', function(){ setWidth(words[idx]); });

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced) return;

  setInterval(function(){
    var prev = idx; idx = (idx+1) % words.length;
    spans[prev].classList.remove('is-in'); spans[prev].classList.add('is-out');
    spans[idx].classList.remove('is-out'); spans[idx].classList.add('is-in');
    setWidth(words[idx]);
  }, 2600);
})();

/* ---------- proof of success: count up once when scrolled into view ---------- */
(function(){
  var stats = document.getElementById('proof');
  if(!stats) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function countUp(el){
    var target = parseFloat(el.getAttribute('data-count'));
    var prefix = el.getAttribute('data-prefix') || '';
    var suffix = el.getAttribute('data-suffix') || '';
    if(isNaN(target)){ return; }
    if(reduced){ el.textContent = prefix + target + suffix; return; }
    var dur = 1300, start = null;
    function ease(t){ return 1 - Math.pow(1 - t, 3); }
    function tick(now){
      if(start===null) start = now;
      var p = Math.min(1, (now - start) / dur);
      el.textContent = prefix + Math.round(target * ease(p)) + suffix;
      if(p < 1) requestAnimationFrame(tick);
      else el.textContent = prefix + target + suffix;
    }
    el.textContent = prefix + '0' + suffix;
    requestAnimationFrame(tick);
  }
  function run(){
    var nums = stats.querySelectorAll('.num-mono[data-count]');
    Array.prototype.forEach.call(nums, function(el, i){
      setTimeout(function(){ countUp(el); }, reduced ? 0 : i * 90);
    });
  }

  if(!('IntersectionObserver' in window)){ run(); return; }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ run(); io.disconnect(); }});
  },{threshold:0.35});
  io.observe(stats);
})();

/* ---------- How it works: hover-driven cumulative build (no scroll) ---------- */
(function(){
  var sec = document.getElementById('how');
  if(!sec) return;
  var steps = Array.prototype.slice.call(sec.querySelectorAll('.step'));
  var layers = Array.prototype.slice.call(sec.querySelectorAll('.ac-layer'));
  var pds = Array.prototype.slice.call(sec.querySelectorAll('.ac-progress .pd'));
  var badge = document.getElementById('acBadge');
  var stepName = document.getElementById('acStepName');
  var names = {1:'Issue',2:'Distribute',3:'Manage'};
  var badges = {1:'On T-REX Ledger',2:'Distributed',3:'In service'};

  // show layers up to n; mark steps; update labels.
  function focusStep(n){
    steps.forEach(function(s){ s.classList.toggle('active', +s.dataset.step===n); });
    layers.forEach(function(l){ l.classList.toggle('on', +l.dataset.layer<=n); });
    pds.forEach(function(p,i){ var idx=i+1; p.classList.toggle('done', idx<n); p.classList.toggle('cur', idx===n); });
    if(badge){ badge.textContent = badges[n]; badge.classList.toggle('svc', n === 3); }
    if(stepName) stepName.textContent = names[n];
  }

  // resting state: the card is fully assembled (all three layers visible),
  // and all steps read as active. nothing depends on scroll.
  function assembled(){
    steps.forEach(function(s){ s.classList.add('active'); });
    layers.forEach(function(l){ l.classList.add('on'); });
    pds.forEach(function(p){ p.classList.add('done'); });
    if(badge){ badge.textContent = badges[3]; badge.classList.add('svc'); }
    if(stepName) stepName.textContent = names[3];
  }

  steps.forEach(function(s){
    var n = +s.dataset.step;
    s.addEventListener('mouseenter', function(){ focusStep(n); });
    // NOTE: We intentionally do NOT bind 'focusin' here. React Router's
    // scroll restoration / auto-focus fires a focusin on the first anchor
    // inside step 1 immediately after mount, which would call focusStep(1)
    // and collapse the fully-assembled resting state back down to layer 1
    // only. Removing this preserves the "card fully assembled by default"
    // behaviour the user requested.
  });
  /* the card holds the last hovered step; it does not unfold on mouse-leave */

  /* scroll-driven unfold: each step's top crossing the upper 40% of the viewport
     advances the build (never reverses), so readers who never hover still see it */
  var maxReached = 1, hovering = false, raf = 0;
  steps.forEach(function(s){
    s.addEventListener('mouseenter', function(){ hovering = true; });
  });
  var stepsWrap = document.getElementById('hiwSteps');
  if(stepsWrap){ stepsWrap.addEventListener('mouseleave', function(){ hovering = false; }); }
  function onScroll(){
    if(raf) return;
    raf = requestAnimationFrame(function(){
      raf = 0;
      var line = window.innerHeight * 0.4, highest = maxReached;
      steps.forEach(function(s){ if(s.getBoundingClientRect().top < line){ var n = +s.dataset.step; if(n > highest) highest = n; } });
      if(highest > maxReached){ maxReached = highest; if(!hovering) focusStep(maxReached); }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  focusStep(1);
  onScroll();
})();

/* ---------- The next entry: three plates, settle-in once ---------- */
(function(){
  var sec = document.getElementById('whofor'); if(!sec || !sec.classList.contains('wxp')) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(reduced || !('IntersectionObserver' in window)) return;
  sec.classList.add('wx-pre');
  var io = new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ sec.classList.remove('wx-pre'); io.disconnect(); } });
  }, { threshold: 0.15 });
  io.observe(sec.querySelector('.wx-plates'));
})();

/* ---------- The Apex commitment: count $0 -> $100,000,000,000 ---------- */
/* behaves like the Proof-of-Success counters: counts once on scroll-in,
   then stops. no perpetual animation (which kept the main thread busy). */
(function(){
  var sec = document.getElementById('apex');
  var out = document.getElementById('apexCount');
  if(!sec || !out) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var START  = 90000000000;    // $90,000,000,000
  var TARGET = 100000000000;   // $100,000,000,000
  var DUR = 1000;

  function fmt(n){ return n.toLocaleString('en-US'); }

  function run(){
    if(reduced){ out.textContent = fmt(TARGET); return; }
    var start = null, last = '';
    function ease(t){ return 1 - Math.pow(1 - t, 3); }   // easeOutCubic (matches Proof)
    function tick(now){
      if(start===null) start = now;
      var p = Math.min(1, (now - start) / DUR);
      var s = fmt(Math.floor(START + (TARGET - START) * ease(p)));
      if(s !== last){ out.textContent = s; last = s; }   // only write when it changes
      if(p < 1) requestAnimationFrame(tick);
      else out.textContent = fmt(TARGET);
    }
    out.textContent = fmt(START);
    requestAnimationFrame(tick);
  }

  if(!('IntersectionObserver' in window)){ run(); return; }
  var io = new IntersectionObserver(function(es){
    es.forEach(function(e){ if(e.isIntersecting){ run(); io.disconnect(); }});
  },{threshold:0.35});
  io.observe(sec);
})();

/* ===== HERO BACKGROUND , the interconnected network sphere =====
   A globe of nodes wired to their neighbours. Dots travel ALONG the surface connections
   between points, routing hop to hop around the network , an interconnected system, all
   contained within the sphere. Right-anchored, flat, champagne, subtle behind the headline.
   A=Network (balanced)  B=Dense  C=Calm */
(function(){
  var cv=document.getElementById('heroBg'); if(!cv) return;
  var ctx=cv.getContext('2d');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var CHAMP='168,139,74', CHAMPL='232,217,184', GOLD='244,213,138';
  var W,H,DPR,S, pick='A', raf=0, running=false, t0=performance.now(), last=performance.now();
  var rot=0, tilt=-0.30, cx,cy,R;
  var CFG={ A:{nodes:150, nb:6, travelers:5, spin:0.00006}, B:{nodes:190, nb:7, travelers:5, spin:0.00006}, C:{nodes:120, nb:6, travelers:4, spin:0.00005} };
  var nets={};

  function geom(){ cx=W*1.0; cy=H*0.52; R=Math.min(H*0.64, W*0.42); }
  function eo(x){ return 1-Math.pow(1-x,3); }
  function v3(lat,lon){ return [Math.cos(lat)*Math.cos(lon),Math.sin(lat),Math.cos(lat)*Math.sin(lon)]; }
  function proj(lat,lon){ var lo=lon+rot; var x3=Math.cos(lat)*Math.cos(lo), y3=Math.sin(lat), z3=Math.cos(lat)*Math.sin(lo);
    var y2=y3*Math.cos(tilt)-z3*Math.sin(tilt), z2=y3*Math.sin(tilt)+z3*Math.cos(tilt);
    return {x:cx+x3*R, y:cy+y2*R, depth:(z2+1)/2, z:z2}; }
  function slerp(a,b,f){ var A=v3(a.lat,a.lon),B=v3(b.lat,b.lon); var d=A[0]*B[0]+A[1]*B[1]+A[2]*B[2]; d=Math.max(-1,Math.min(1,d)); var om=Math.acos(d);
    if(om<1e-4) return a; var s1=Math.sin((1-f)*om)/Math.sin(om), s2=Math.sin(f*om)/Math.sin(om);
    var x=A[0]*s1+B[0]*s2,y=A[1]*s1+B[1]*s2,z=A[2]*s1+B[2]*s2; return {lat:Math.asin(Math.max(-1,Math.min(1,y))),lon:Math.atan2(z,x)}; }

  function build(key){ var c=CFG[key]; var nodes=[], ga=Math.PI*(3-Math.sqrt(5));
    for(var i=0;i<c.nodes;i++){ var y=1-(i/(c.nodes-1))*2, rr=Math.sqrt(1-y*y), th=ga*i; nodes.push({lat:Math.asin(y),lon:Math.atan2(Math.sin(th)*rr,Math.cos(th)*rr)}); }
    // adjacency: nearest nb neighbours (kept short so the mesh reads compact)
    var adj=[]; for(var a=0;a<nodes.length;a++){ var da=[]; for(var b=0;b<nodes.length;b++){ if(a===b) continue; var A=v3(nodes[a].lat,nodes[a].lon),B=v3(nodes[b].lat,nodes[b].lon); da.push({b:b,d:A[0]*B[0]+A[1]*B[1]+A[2]*B[2]}); } da.sort(function(p,q){return q.d-p.d;}); adj.push(da.slice(0,c.nb).map(function(o){return o.b;})); }
    // edge list (unique)
    var edges=[], seen={}; for(var a=0;a<adj.length;a++){ for(var k=0;k<adj[a].length;k++){ var b=adj[a][k]; var key2=Math.min(a,b)+'-'+Math.max(a,b); if(!seen[key2]){ seen[key2]=1; edges.push([a,b]); } } }
    // travelers hopping node->node along adjacency (count varies 2-5, managed in draw)
    var trav=[]; var startN=6+((Math.random()*7)|0); for(var i=0;i<startN;i++){ var n0=(Math.random()*nodes.length)|0; trav.push(newTrav(nodes,adj,n0)); }
    nets[key]={nodes:nodes,adj:adj,edges:edges,trav:trav,target:startN,timer:0};
  }
  function newTrav(nodes,adj,from){ var nbrs=adj[from]; var to=nbrs[(Math.random()*nbrs.length)|0];
    return {from:from,to:to,prog:Math.random()*0.5,sp:0.35+Math.random()*0.4,a:0.5+Math.random()*0.4}; }
  function buildA(){build('A');} function buildB(){build('B');} function buildC(){build('C');}
  function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); S=Math.min(Math.max(W/1440,0.65),1.4); geom(); buildA(); buildB(); buildC(); }

  function drawEdge(na,nb){ var steps=10, prev=null;
    for(var i=0;i<=steps;i++){ var sp=slerp(na,nb,i/steps); var pr=proj(sp.lat,sp.lon); if(pr.z<-0.04){prev=null;continue;}
      if(prev){ var a=0.10*((prev.depth+pr.depth)/2); ctx.strokeStyle='rgba('+CHAMP+','+a.toFixed(3)+')'; ctx.lineWidth=0.6*S; ctx.beginPath(); ctx.moveTo(prev.x,prev.y); ctx.lineTo(pr.x,pr.y); ctx.stroke(); } prev=pr; } }

  function drawNet(key,dt){ ctx.clearRect(0,0,W,H); var net=nets[key];
    // edges (the interconnections)
    for(var e=0;e<net.edges.length;e++){ drawEdge(net.nodes[net.edges[e][0]],net.nodes[net.edges[e][1]]); }
    // nodes
    for(var i=0;i<net.nodes.length;i++){ var p=proj(net.nodes[i].lat,net.nodes[i].lon); if(p.z<-0.06) continue;
      var a=0.14+p.depth*0.34; ctx.fillStyle='rgba('+(p.depth>0.6?CHAMPL:CHAMP)+','+a.toFixed(3)+')'; ctx.beginPath(); ctx.arc(p.x,p.y,(0.6+p.depth*1.1)*S,0,6.283); ctx.fill(); }
    // keep the active traveler count drifting between 2 and 5
    net.timer-=dt; if(net.timer<=0){ net.timer=1.5+Math.random()*2.5; net.target=6+((Math.random()*7)|0); }
    if(net.trav.length<net.target){ var n0=(Math.random()*net.nodes.length)|0; net.trav.push(newTrav(net.nodes,net.adj,n0)); }
    else if(net.trav.length>net.target){ net.trav.pop(); }
    // travelers hopping along edges
    for(var t=0;t<net.trav.length;t++){ var tr=net.trav[t]; tr.prog+=tr.sp*dt;
      var na=net.nodes[tr.from], nb=net.nodes[tr.to];
      if(tr.prog>=1){ // arrived at a node -> pick a new neighbour to hop to (route on)
        var nbrs=net.adj[tr.to]; var nxt=nbrs[(Math.random()*nbrs.length)|0];
        tr.from=tr.to; tr.to=nxt; tr.prog=0; tr.sp=0.35+Math.random()*0.4; na=net.nodes[tr.from]; nb=net.nodes[tr.to]; }
      var e=eo(tr.prog); var sp=slerp(na,nb,e); var pr=proj(sp.lat,sp.lon); if(pr.z<-0.04) continue;
      // short bright trail behind the traveler along the edge
      var sp0=slerp(na,nb,Math.max(0,e-0.18)); var pr0=proj(sp0.lat,sp0.lon);
      if(pr0.z>-0.04){ var g=ctx.createLinearGradient(pr0.x,pr0.y,pr.x,pr.y); g.addColorStop(0,'rgba('+GOLD+',0)'); g.addColorStop(1,'rgba('+GOLD+','+(tr.a*pr.depth).toFixed(3)+')'); ctx.strokeStyle=g; ctx.lineWidth=1.1*S; ctx.beginPath(); ctx.moveTo(pr0.x,pr0.y); ctx.lineTo(pr.x,pr.y); ctx.stroke(); }
      ctx.fillStyle='rgba('+GOLD+','+(tr.a*pr.depth+0.15).toFixed(3)+')'; ctx.beginPath(); ctx.arc(pr.x,pr.y,1.5*S,0,6.283); ctx.fill();
    }
    // faint rim
    ctx.strokeStyle='rgba('+CHAMPL+',0.10)'; ctx.lineWidth=1*S; ctx.beginPath(); ctx.arc(cx,cy,R,0,6.283); ctx.stroke();
  }

  function loop(now){ var dt=Math.min(0.05,(now-last)/1000); last=now; var t=now-t0; rot=t*CFG[pick].spin;
    drawNet(pick,dt);
    if(running&&!reduced) raf=requestAnimationFrame(loop);
  }
  function start(){ if(running)return; running=true; last=performance.now(); raf=requestAnimationFrame(loop); }
  function stop(){ running=false; cancelAnimationFrame(raf); }
  size();
  if(reduced){ rot=0.5; drawNet('A',0); } else { start(); }
  window.addEventListener('resize', size);
  if('IntersectionObserver' in window && !reduced){ var io=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start():stop(); });},{threshold:0.01}); io.observe(cv); }
})();

/* seamless partner marquees: duplicate each track's content once
   Uses cloneNode + appendChild instead of innerHTML string concat so we
   never reparse HTML (defensive against XSS finding on innerHTML+=). */
(function(){
  ['mqA','mqB'].forEach(function(id){
    var t=document.getElementById(id); if(!t) return;
    var kids=Array.prototype.slice.call(t.children);
    kids.forEach(function(k){ t.appendChild(k.cloneNode(true)); });
  });
})();

/* flywheel canvas animation for #loop-arc (the "why it matters" beat).
   Direct port of the artifact JS: orbital ellipse with three labelled
   nodes, a champagne-amber comet tracing the loop, a radial core, and
   a subtle sunburst. Starts on IntersectionObserver, respects
   prefers-reduced-motion. */
(function(){
  var wrap=document.getElementById('flywheel'); if(!wrap) return;
  var cv=document.getElementById('fwCanvas'); if(!cv) return;
  var ctx=cv.getContext('2d');
  var labels=[].slice.call(wrap.querySelectorAll('.fw-label'));
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dpr=Math.min(window.devicePixelRatio||1,2);
  var W,H,cx,cy,R, RY=0.42;
  var OR='255,122,51', AM='255,170,92', AUB='21,16,42';
  var A=[-Math.PI/2, Math.PI/6, 5*Math.PI/6];
  var t=0, spin=0, last=0, raf=0, running=false, pulses=[];
  function pt(a,r){ return [cx+r*Math.cos(a), cy+r*RY*Math.sin(a)]; }
  function depth(a){ return 0.5+0.5*(Math.sin(a)*0.5+0.5); }
  function size(){
    var r=wrap.getBoundingClientRect(); W=r.width; H=r.height;
    cv.width=Math.round(W*dpr); cv.height=Math.round(H*dpr);
    cv.style.width=W+'px'; cv.style.height=H+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    var narrow = W < 720;
    cx=W/2; cy=H*(narrow?0.48:0.52);
    // Slightly tighter radius on mobile so side labels can breathe
    R=Math.min(W*(narrow?0.32:0.38), H*(narrow?0.72:0.85));
    var p, sideOff = narrow ? 8 : 16, topOff = narrow ? 12 : 16;
    p=pt(A[0],R);
    if(labels[0]){ labels[0].style.transform='translate(-50%,-100%)'; labels[0].style.left=p[0]+'px'; labels[0].style.top=(p[1]-topOff)+'px'; }
    p=pt(A[1],R);
    if(labels[1]){
      if(narrow){
        // stack under the node: keeps label fully inside the viewport
        labels[1].style.transform='translate(-50%,0)';
        labels[1].style.left=p[0]+'px';
        labels[1].style.top=(p[1]+sideOff+2)+'px';
      } else {
        labels[1].style.transform='translate(0,-50%)';
        labels[1].style.left=(p[0]+sideOff)+'px';
        labels[1].style.top=p[1]+'px';
      }
    }
    p=pt(A[2],R);
    if(labels[2]){
      if(narrow){
        labels[2].style.transform='translate(-50%,0)';
        labels[2].style.left=p[0]+'px';
        labels[2].style.top=(p[1]+sideOff+2)+'px';
      } else {
        labels[2].style.transform='translate(-100%,-50%)';
        labels[2].style.left=(p[0]-sideOff)+'px';
        labels[2].style.top=p[1]+'px';
      }
    }
  }
  function sunburst(){
    var N=112, inner=R*0.05;
    ctx.save(); ctx.translate(cx,cy);
    for(var i=0;i<N;i++){ var a=i/N*Math.PI*2 + spin; var d=0.5+0.5*(Math.sin(a)*0.5+0.5);
      ctx.beginPath();
      ctx.moveTo(Math.cos(a)*inner, Math.sin(a)*inner*RY);
      ctx.lineTo(Math.cos(a)*R, Math.sin(a)*R*RY);
      ctx.strokeStyle='rgba('+OR+','+(0.04+0.13*d)+')';
      ctx.lineWidth=0.7+0.8*d; ctx.stroke(); }
    ctx.restore();
  }
  function core(){
    var rr=R*0.14;
    var g=ctx.createRadialGradient(cx,cy,0,cx,cy,rr);
    g.addColorStop(0,'rgba(255,150,80,0.55)');
    g.addColorStop(0.5,'rgba('+OR+',0.28)');
    g.addColorStop(1,'rgba('+OR+',0)');
    ctx.save(); ctx.shadowBlur=24; ctx.shadowColor='rgba('+OR+',0.35)';
    ctx.fillStyle=g; ctx.beginPath(); ctx.arc(cx,cy,rr,0,7); ctx.fill(); ctx.restore();
  }
  function orbit(){
    ctx.save(); ctx.lineCap='round';
    ctx.beginPath(); ctx.ellipse(cx,cy,R,R*RY,0,0,7);
    ctx.strokeStyle='rgba('+OR+',0.14)'; ctx.lineWidth=2.8; ctx.setLineDash([]); ctx.stroke();
    ctx.beginPath(); ctx.ellipse(cx,cy,R,R*RY,0,Math.PI,Math.PI*2);
    ctx.strokeStyle='rgba('+OR+',0.40)'; ctx.lineWidth=2.0; ctx.setLineDash([2.5,5]); ctx.stroke();
    ctx.beginPath(); ctx.ellipse(cx,cy,R,R*RY,0,0,Math.PI);
    ctx.strokeStyle='rgba('+OR+',0.75)'; ctx.lineWidth=2.7; ctx.setLineDash([2.5,5]); ctx.stroke();
    ctx.restore();
  }
  function drawNodes(){
    A.forEach(function(na){
      var dd=Math.abs(((t-na+Math.PI)%(2*Math.PI))-Math.PI);
      var fl=Math.max(0,1-dd/0.5);
      var p=pt(na,R); var d=depth(na); var rad=(4.8+fl*3.6)*(0.78+0.22*d);
      if(fl>0.02){ ctx.save(); ctx.shadowBlur=7+fl*24; ctx.shadowColor='rgba('+OR+','+(0.5+fl*0.5)+')';
        ctx.beginPath(); ctx.arc(p[0],p[1],rad,0,7); ctx.fillStyle='rgba(255,150,80,'+(0.55+fl*0.45)+')'; ctx.fill(); ctx.restore(); }
      ctx.beginPath(); ctx.arc(p[0],p[1],3.8,0,7); ctx.fillStyle='rgba('+AUB+',0.92)'; ctx.fill();
      ctx.beginPath(); ctx.arc(p[0],p[1],9+fl*4,0,7); ctx.strokeStyle='rgba('+OR+','+(0.45+fl*0.5)+')'; ctx.lineWidth=1.5; ctx.stroke();
    });
  }
  function comet(){
    for(var k=36;k>=1;k--){ var a=t-k*0.04; var p=pt(a,R); var fk=1-k/36; var d=depth(a);
      ctx.beginPath(); ctx.arc(p[0],p[1],(1.4+fk*2.9)*d,0,7);
      ctx.fillStyle='rgba('+OR+','+(fk*0.7*d)+')'; ctx.fill(); }
    var hp=pt(t,R); var hd=depth(t);
    ctx.save(); ctx.shadowBlur=22; ctx.shadowColor='rgba('+OR+',0.7)';
    var g=ctx.createRadialGradient(hp[0],hp[1],0,hp[0],hp[1],11*hd);
    g.addColorStop(0,'rgba(255,214,150,1)');
    g.addColorStop(0.4,'rgba('+AM+',1)');
    g.addColorStop(0.75,'rgba('+OR+',1)');
    g.addColorStop(1,'rgba('+OR+',0)');
    ctx.fillStyle=g; ctx.beginPath(); ctx.arc(hp[0],hp[1],11*hd,0,7); ctx.fill(); ctx.restore();
  }
  function drawPulses(){
    for(var i=pulses.length-1;i>=0;i--){ var pu=pulses[i]; pu.age++;
      var pr=9+pu.age*2, al=0.5-pu.age*0.014;
      if(al<=0){pulses.splice(i,1);continue;}
      var p=pt(pu.a,R);
      ctx.beginPath(); ctx.arc(p[0],p[1],pr,0,7);
      ctx.strokeStyle='rgba('+OR+','+al+')'; ctx.lineWidth=1.4; ctx.stroke(); }
  }
  function draw(){ ctx.clearRect(0,0,W,H); sunburst(); core(); orbit(); drawPulses(); comet(); drawNodes(); }
  function loop(now){
    if(!last) last=now;
    var dt=Math.min(0.05,(now-last)/1000); last=now;
    var prev=t; t+=dt*0.55; spin+=dt*0.12;
    A.forEach(function(na){
      var a0=(((prev-na)%(2*Math.PI))+2*Math.PI)%(2*Math.PI);
      var a1=(((t-na)%(2*Math.PI))+2*Math.PI)%(2*Math.PI);
      if(a1<a0) pulses.push({a:na,age:0});
    });
    draw(); if(running) raf=requestAnimationFrame(loop);
  }
  function start(){ if(running||reduced) return; running=true; last=0; raf=requestAnimationFrame(loop); }
  function stop(){ running=false; cancelAnimationFrame(raf); }
  size(); draw();
  window.addEventListener('resize', function(){ size(); if(!running) draw(); });
  if('IntersectionObserver' in window && !reduced){
    new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); }, {threshold:0.12}).observe(wrap);
  } else if(!reduced){ start(); }
})();


/* ---- THE STACK: exploded plate as tablist (reader-paced, APG tabs) ---- */
(function(){
  var sec = document.getElementById('stack'); if(!sec || !sec.classList.contains('stackx')) return;
  var tabs = Array.prototype.slice.call(sec.querySelectorAll('.sx-slab[role="tab"]'));
  var panels = Array.prototype.slice.call(sec.querySelectorAll('.sx-panel'));
  if(!tabs.length || tabs.length !== panels.length) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function select(i, focus){
    tabs.forEach(function(t, j){
      var on = j === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
    });
    panels.forEach(function(p, j){
      if(j === i){ p.hidden = false; p.classList.remove('sx-in'); void p.offsetWidth; p.classList.add('sx-in'); }
      else { p.hidden = true; p.classList.remove('sx-in'); }
    });
    if(focus) tabs[i].focus();
  }

  tabs.forEach(function(t, i){
    t.addEventListener('click', function(){ select(i, false); });
    t.addEventListener('keydown', function(e){
      var k = e.key, n = null;
      if(k === 'ArrowDown' || k === 'ArrowRight') n = (i + 1) % tabs.length;
      else if(k === 'ArrowUp' || k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
      else if(k === 'Home') n = 0;
      else if(k === 'End') n = tabs.length - 1;
      else if(k === 'Enter' || k === ' ') n = i;
      if(n !== null){ e.preventDefault(); select(n, true); }
    });
  });

  /* entrance: settle once on first view; resting state is fully visible, so
     no-JS and reduced-motion readers never see hidden content */
  if(!reduced && 'IntersectionObserver' in window){
    sec.classList.add('sx-pre');
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(en.isIntersecting){ sec.classList.remove('sx-pre'); io.disconnect(); }
      });
    }, { threshold: 0.25 });
    io.observe(sec.querySelector('.stackx-fig'));
  }
})();


/* ---------- The record of opinion: snap carousel on the thread ---------- */
(function(){
  var track = document.getElementById('vrTrack');
  if(!track) return;
  var entries = Array.prototype.slice.call(track.querySelectorAll('.vr-entry'));
  var nodes = Array.prototype.slice.call(document.querySelectorAll('.vr-node'));
  var prev = document.getElementById('vrPrev'), next = document.getElementById('vrNext');
  var counter = document.getElementById('vrCounter'), counterNum = document.getElementById('vrCounterNum'), fill = document.getElementById('vrFill');
  if(!entries.length) return;
  var active = 0;
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function setCounter(i){
    if(!counterNum) return;
    var next = pad(i + 1);
    if(counterNum.textContent === next) return;   /* skip redundant writes so the flip animation never restarts on itself */
    counterNum.classList.remove('is-flip');
    void counterNum.offsetWidth;                    /* force reflow so the animation replays cleanly on each change */
    counterNum.textContent = next;
    counterNum.classList.add('is-flip');
  }
  function setNav(i){
    nodes.forEach(function(n, j){ n.classList.toggle('is-active', j === i); });
    setCounter(i);
    if(fill && nodes[i]){ fill.style.width = (nodes[i].offsetLeft + nodes[i].offsetWidth / 2) + 'px'; }
  }
  function setActive(i){
    active = i;
    entries.forEach(function(e, j){ e.classList.toggle('is-active', j === i); });
    nodes.forEach(function(n, j){ n.classList.toggle('is-active', j === i); });
    setCounter(i);
    if(fill && nodes[i]){ fill.style.width = (nodes[i].offsetLeft + nodes[i].offsetWidth / 2) + 'px'; }
    if(prev) prev.disabled = i <= 0;
    if(next) next.disabled = i >= entries.length - 1;
  }
  function goTo(i){
    i = Math.max(0, Math.min(entries.length - 1, i));
    active = i;
    setNav(i);            /* thread and counter respond now; plates follow the scroll */
    track.scrollTo({ left: entries[i].offsetLeft - parseFloat(getComputedStyle(track).paddingLeft), behavior: 'smooth' });
  }
  if('IntersectionObserver' in window){
    var ratios = entries.map(function(){ return 0; });
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ ratios[entries.indexOf(en.target)] = en.intersectionRatio; });
      /* active = leftmost entry that is (almost) fully in view; when the
         carousel is scrolled to the very end and two entries are equally
         in view we prefer the RIGHTMOST match, otherwise the counter
         would freeze on N-1 while the user is looking at entry N. */
      var i = -1;
      var atEnd = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 4);
      if(atEnd){
        for(var k = ratios.length - 1; k >= 0; k--){ if(ratios[k] >= 0.9){ i = k; break; } }
      } else {
        for(var k = 0; k < ratios.length; k++){ if(ratios[k] >= 0.9){ i = k; break; } }
      }
      if(i < 0){ var m = 0; for(var k2 = 0; k2 < ratios.length; k2++){ if(ratios[k2] > m){ m = ratios[k2]; i = k2; } } }
      if(i >= 0 && i !== active) setActive(i);
    }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 0.9, 1] });
    entries.forEach(function(e){ io.observe(e); });
  }
  entries.forEach(function(e, i){ e.addEventListener('click', function(){ if(i !== active) goTo(i); }); });
  nodes.forEach(function(n){ n.addEventListener('click', function(){ goTo(+n.dataset.go - 1); }); });
  if(prev) prev.addEventListener('click', function(){ goTo(active - 1); });
  if(next) next.addEventListener('click', function(){ goTo(active + 1); });
  track.addEventListener('keydown', function(e){
    if(e.key === 'ArrowRight'){ e.preventDefault(); goTo(active + 1); }
    if(e.key === 'ArrowLeft'){ e.preventDefault(); goTo(active - 1); }
    if(e.key === 'Home'){ e.preventDefault(); goTo(0); }
    if(e.key === 'End'){ e.preventDefault(); goTo(entries.length - 1); }
  });
  setActive(0);
})();

`;
